


$(document).ready(function() {
    var gwpid = $('.gwp-product').attr('attr');
  var gwpPrice = $('.gwp-product').attr('gwp_price')

  function updateCart(action, quantity) {
        quantity = Math.min(quantity, 1);

        $.ajax({
            type: 'POST',
            url: action === 'add' ? '/cart/add.js' : '/cart/change.js',
            data: {
                id: parseInt(gwpid),
                quantity: quantity
            },
            dataType: 'json',
            success: function() {
                $.ajax({
                    type: 'GET',
                    url: '/cart',
                    dataType: 'html',
                    success: function(cart) {
                        $('.cart-drawer').html($(cart).find('.cart-drawer').html());
                    },
                    error: function() {
                        console.error('Error fetching cart.');
                    }
                });
            },
            error: function() {
                console.error('Error updating cart.');
            }
        });
    }

    function handleCartCheck() {
        var total_cart_price = parseFloat($('.cart__total__price').attr('data-cart-total')) / 100;
         var gwppro = $('.cstm-gwp-product').prop('outerHTML');
        $.ajax({
            type: 'GET',
            url: '/cart',
            dataType: 'json',
            success: function(cart) {
                var itemInCart = false;
                var itemQuantity = 0;

                cart.items.forEach(function(item) {
                    if (item.id === parseInt(gwpid)) {
                        itemInCart = true;
                        itemQuantity = item.quantity;
                    }
                });

                if (total_cart_price < gwpPrice) {
                    if (itemInCart && itemQuantity > 0) {
                        updateCart('remove', 0);
             
                    }
                } else if (total_cart_price > gwpPrice) {
                   $('.cstm-gwp-product').show();
                    if (!itemInCart || itemQuantity === 0) {
                        updateCart('add', 1);
                      
                    }
                }

            },
            error: function() {
                console.error('Error fetching cart.');
            }
        });
    

    }

    $('[type=submit]').click(function() {
              setTimeout(handleCartCheck, 1900);



      
    });

    function triggerAlert() {
        setTimeout(handleCartCheck, 1900);
   
 
 
    }

    $('.drawer__inner').on('click keyup', function(event) {
        if (event.type === 'click' || (event.type === 'keyup' && event.key === 'Enter')) {
            triggerAlert();
        }
    });

    // Ensure handleCartCheck is not called on page load
});


 setInterval(function() {
$(document).ready(function() {
    var totalBubble = 0;

    $('.cart__quantity-field').each(function() {
      
        var bubble = $(this).val(); 
        var bubbleInt = parseInt(bubble, 10) || 0; 

       
        totalBubble += bubbleInt;
    });

  
    var totalquant = $('.cstm-gwp-product').length;

    
    var newbubble = totalBubble + totalquant;

   
    $('.header__cart__status').text(newbubble);
    $('.cart__items-count').text(newbubble);
});

 }, 1000);


  
  